import { GetterTree } from 'vuex';
import { AssignmentStatus, GroupFormationState } from '@/store/groups/formation/types';
import { RootState } from '@/store/types';
import { Semester } from '@/store/master/types';

const getters : GetterTree<GroupFormationState, RootState> = {
  /**
   * 年度学期とグループ編成名を元に、グループアサインステータスを取得
   * @param {number} fiscalYear 年度
   * @param {Semester} semester 学期
   * @param {string} name グループ編成名
   */
  findGroupAssignmentStatus: (state) => (
    fiscalYear: number,
    semester: Semester,
    name: string,
  ): AssignmentStatus|null => {
    return state.assignments.find((assignment: AssignmentStatus) => {
      return assignment.year === fiscalYear
        && assignment.semester.code === semester?.code
        && assignment.name === name
    }) || null
  },
}

export default getters;
